export default __webpack_public_path__ + "static/media/Archpriest's Gloves of the Underworld.5825c4d2.jpg";